import { getCurrentIdToken } from '@heyroot/auth-shared';

export class AuthNotReadyError extends Error {
  constructor() {
    super('auth-not-ready');
    this.name = 'AuthNotReadyError';
    Object.setPrototypeOf(this, AuthNotReadyError.prototype);
  }
}

let refreshPromise: Promise<string | null> | null = null;
function refreshOnce(): Promise<string | null> {
  if (!refreshPromise)
    refreshPromise = getCurrentIdToken(true).finally(() => {
      refreshPromise = null;
    });
  return refreshPromise;
}

export async function authenticatedFetch(
  url: string,
  options: RequestInit = {},
): Promise<Response> {
  let token = await getCurrentIdToken();
  if (!token) token = await getCurrentIdToken(true);
  if (!token) throw new AuthNotReadyError();

  const make = (t: string) =>
    fetch(url, {
      ...options,
      headers: { ...(options.headers ?? {}), Authorization: `Bearer ${t}` },
    });
  let res = await make(token);
  if (res.status === 401) {
    const body = await res
      .clone()
      .json()
      .catch(() => ({}));
    if (body.code === 'TOKEN_STALE') {
      const refreshed = await refreshOnce();
      if (!refreshed) throw new AuthNotReadyError();
      res = await make(refreshed);
    }
  }
  return res;
}
